import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createQueryDefinition } from 'common/services/queryBuilder';

import { listOrganizations, createOrganization } from './services';

export const organizationSearchQueryOptions = search => ({
  queryKey: ['managemobi', 'organizations', 'search', search],
  queryFn: () => listOrganizations({ search, limit: 10, sort: 'name' }),
  select: ({ data }) => data,
  enabled: !!search,
});

export const OrganizationListQueryKey = createQueryDefinition(
  (search, query) => ['managemobi', 'organizations', 'list', query],
  ({ queryKey: [, , , query] }) => listOrganizations(query),
);

export const useCreateOrganizationMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: data => createOrganization(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['managemobi', 'organizations', 'list'],
      });
    },
  });
};
